<template>
  <div class="mt-3">
    <div>
      promotion code: {{ promotion_code }}
      <v-btn icon small>
        <v-icon @click="load()">mdi-reload</v-icon>
      </v-btn>
    </div>
    <v-data-table :headers="headers" :items="userRecords" :search="search" :loading="loading">
      <template #[`item.country`]="{ item }">
        {{ item.country ? item.country.name : '' }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: ['ambassadorId'],

  data() {
    return {
      headers: [
        { text: 'Name on fondi', value: 'user.name' },
        { text: 'email', value: 'email' },
        { text: 'Country', value: 'country' },
        { text: 'Created / Registered(GMT)', value: 'changed_at' },
      ],
      search: '',
      promotion_code: null,
      userRecords: [],
      loading: false,
    };
  },

  watch: {
    ambassadorId() {
      this.load();
    },
  },

  mounted() {
    this.load();
  },

  methods: {
    async load() {
      if (!this.ambassadorId) return;
      this.loading = true;
      try {
        var response = await axios.get(
          `/admin/ambassadors/promotions/records/${this.ambassadorId}`
        );
        this.userRecords = response.data.user_records;
        this.promotion_code = response.data.promotion_code;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
